import { type PropsWithChildren } from 'react';
import { Header, HStack, VStack } from '@direct-frontend/components';
import type { OrderProductVariant } from '@/shared/api/order';
import {
    OrderProductCharacteristics,
    OrderProductImage,
    OrderProductInfo,
    type OrderProductProps,
} from '@/shared/components/OrderProduct';
import { getProductImage } from '@/shared/lib/getProductImage';
import { getRequestContext } from '@/shared/lib/requestContext';
import styles from './CheckoutFeedbackChunk.module.css';

interface CheckoutFeedbackChunkProps extends PropsWithChildren {
    title?: string;
    items: OrderProductVariant[];
}

const CheckoutOrderProduct = (
    props: Omit<
        OrderProductProps,
        'canRemoved' | 'maxQuantity' | 'updateProductQuantity' | 'chunkId' | 'variantId' | 'reinitialize'
    >
) => {
    const { image, url, name, isExpressCheckout, caption, quantity, finalPrice, characteristics } = props;

    return (
        <HStack gap="20" alignItems="stretch">
            <OrderProductImage image={image} url={url} name={name} isExpressCheckout={isExpressCheckout} />

            <VStack className={styles.container} gap="8">
                <OrderProductInfo
                    name={name}
                    url={url}
                    caption={caption}
                    finalPrice={finalPrice}
                    quantity={quantity}
                    isExpressCheckout={isExpressCheckout}
                    variantsInfo={<OrderProductCharacteristics characteristics={characteristics} />}
                />
            </VStack>
        </HStack>
    );
};

export const CheckoutFeedbackChunk = (props: CheckoutFeedbackChunkProps) => {
    const { items, title, children } = props;

    const { isExpressCheckout } = getRequestContext();

    return (
        <VStack gap="24">
            <Header level="h3">{title}</Header>

            <VStack gap="16">
                {items.map((item, index) => (
                    <CheckoutOrderProduct
                        key={index}
                        name={item.name}
                        image={getProductImage(item.media[0])}
                        quantity={item.quantity}
                        finalPrice={item.final_price}
                        url={item.link_url}
                        isExpressCheckout={isExpressCheckout}
                        characteristics={item.picker_characteristics}
                    />
                ))}

                {children}
            </VStack>
        </VStack>
    );
};
